<template>
  <div class="list-box dialog-dom">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="付款审批"
    ></div>
    <div class="flex-1 flex flex-col relative overflow-hidden">
      <ul
        class="flex items-center justify-end p-2.5 gap-x-3 absolute right-0"
        style="top: -10px; z-index: 99"
      >
        <el-segmented
          v-model="state.params.is_approve"
          :props="{
            label: 'Text',
            value: 'Key',
          }"
          :options="[
            { Key: 0, Text: '待审批' },
            { Key: 1, Text: '已审批' },
          ]"
          :empty-values="[null, undefined, 0]"
          class="c-segmented"
        />
        <el-input
          v-model="state.keywords"
          class="!w-56"
          clearable
          placeholder="关键字"
          @keyup.enter="state.params.keywords = state.keywords"
        >
          <template #suffix>
            <el-icon
              @click="state.params.keywords = state.keywords"
              color="#a2a2a2"
              title="搜索"
              class="font-bold cursor-pointer hover:opacity-60"
              ><Search
            /></el-icon>
          </template>
        </el-input>
      </ul>
      <el-tabs v-model="state.type" class="c-el-tabs-auto-height">
        <el-tab-pane label="采购付款审批" name="caigou">
          <c_caigou
            v-if="state.type == 'caigou'"
            :params="state.params"
            :key="state.params?.is_approve"
          />
        </el-tab-pane>
        <el-tab-pane label="无采购付款审批" name="wucaigou">
          <c_wucaigou
            v-if="state.type == 'wucaigou'"
            :params="state.params"
            :key="state.params?.is_approve"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
  <el-dialog
    v-model="state.showDetail"
    :title="'人员详情-' + state.selectItem?.name"
    class="c-el-dialog h-full"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 70%"
  >
    <c_detail :id="state.selectItem.id" @close="state.showDetail = false" />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";

import c_caigou from "./CaiGouShenPi.vue";
import c_wucaigou from "./WuCaiGouShenPi.vue";

export default {
  components: {
    c_caigou,
    c_wucaigou,
  },
  setup() {
    const state = reactive({
      type: "caigou",
      params: {
        is_approve: 0,
      },
    });
    onMounted(() => {});

    return {
      state,
    };
  },
};
</script>

<style lang="scss" scoped></style>
